<template>
  <div>
    <!-- <h2 class="title">{{ title }}</h2>
    <div class="content">
    </div> -->
    <div class="homepage">
      <div class="EachScreen">
        <h2>个人简介</h2>
        <div class="content">
          <p class="notTitle" v-if="newList6.content && newList6.content.profile">{{newList6.content.profile}}</p>
          <p v-else class="notData">- 暂无编辑个人简介 -</p>
        </div>
      </div>
      <div class="EachScreen">
        <h2>个人履历</h2>
        <div class="content">
          <div v-if="list[0] && list[0].childList[1] && list[0].childList[1].status == 1">
            <h3>教育背景</h3>
            <p class="notTitle" v-if="newList1.data && newList1.data.content">{{newList1.data.content}}</p>
            <p v-else class="notData">- 暂无编辑教育背景 -</p>
          </div>
          <div v-if="list[0] && list[0].childList[2] && list[0].childList[2].status == 1">
            <h3>工作经历</h3>
            <p class="notTitle" v-if="newList2.data && newList2.data.content">{{newList2.data.content}}</p>
            <p v-else class="notData">- 暂无编辑工作经历 -</p>
          </div>
          <div v-if="list[0] && list[0].childList[3] && list[0].childList[3].status == 1">
            <h3>职称经历</h3>
            <p class="notTitle" v-if="newList3.data && newList3.data.content">{{newList3.data.content}}</p>
            <p v-else class="notData">- 暂无编辑职称经历 -</p>
          </div>
          <div v-if="list[0] && list[0].childList[3] && list[0].childList[3].status == 1">
            <h3>社会任职</h3>
            <p class="notTitle" v-if="newList4.data && newList4.data.content">{{newList4.data.content}}</p>
            <p v-else class="notData">- 暂无编辑社会任职 -</p>
          </div>
        </div>
      </div>
      <div v-if="list[0] && list[0].childList[4] && list[0].childList[4].status == 1" class="EachScreen">
        <h2>获奖情况</h2>
        <div class="content">
          <p class="notTitle" v-if="newList5.data && newList5.data.content">{{newList5.data.content}}</p>
          <p v-else class="notData">- 暂无编辑获奖情况 -</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    userInfo: {
      type: Object,
      default: () => {},
    },
    newList1:{
      type:Object
    },
    newList2:{
      type:Object
    },
    newList3:{
      type:Object
    },
    newList4:{
      type:Object
    },
    newList5:{
      type:Object
    },
    newList6:{
      type:Object
    }
  },
  data(){
    return{
      list:{},
      state1:'',
      state2:'',
      state3:'',
      state4:'',
      state5:'',
      state6:''
    }
  },
  methods:{
        // 获取隐藏状态
   async getPrivacyList(userId){
      // console.log('调用了')
        let res = await this.$apis.userServe.getPrivacyList({userId});
        this.list = res.data

        // this.list.forEach(element => {
        //     console.log(element)
        //   });
        // }

    }
  },
  mounted(){
    this.getPrivacyList(this.$route.query.id)
  }
};
</script>

<style lang="scss" scoped>
.homepage{
  border: 1px solid #A3CBE7;
  border-radius: 10px;
  .EachScreen{
    & h2{
      height: 68px;
      line-height: 68px;
      padding-left: 28px;
      border-bottom: 1px solid #E5E5E5;
    }
    .content{
      width: 100%;
      min-height: 200px;
      padding: 20px 37px 37px 37px;
      white-space: pre-wrap	;
      line-height: 35px;
      .notTitle{
        margin: 10px 0 40px 0;
      }
    }
  }
}
.notData {
  color: #c5c8ce;
  margin: 30px 0 35px 0;
}
</style>
